// extracted by mini-css-extract-plugin
export default {"title":"SideBarTitle_title__DWuf0"};